import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { api } from "@/lib/api";
import { AdminApplications, AdminRsvps, AdminSubscribers } from "@/components/admin/AdminSubmissions";
import { AdminMembers } from "@/components/admin/AdminMembers";
import { AdminFeed } from "@/components/admin/AdminFeed";
import { AdminMailchimp } from "@/components/admin/AdminMailchimp";
import { AdminPosts } from "@/components/admin/AdminPosts";
import { AdminLessons, AdminDiscounts } from "@/components/admin/AdminContent";

const TABS = [
  ["applications", "Applications", AdminApplications],
  ["rsvps", "RSVPs", AdminRsvps],
  ["subscribers", "Tea Subscribers", AdminSubscribers],
  ["members", "Members & Enrollment", AdminMembers],
  ["feed", "Community Feed", AdminFeed],
  ["posts", "Blog Posts", AdminPosts],
  ["lessons", "Lessons", AdminLessons],
  ["discounts", "Discount Codes", AdminDiscounts],
  ["mailchimp", "Mailchimp", AdminMailchimp],
];

export default function Admin() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data));
  }, []);
  return (
    <div data-testid="admin-page" className="max-w-7xl mx-auto px-6 lg:px-10 pt-12">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <span className="eyebrow">Admin Dashboard</span>
          <h1 className="font-serif-h font-light text-4xl sm:text-5xl text-[#577731] mt-3">Tending the circle</h1>
        </div>
        <Link to="/members" data-testid="admin-to-members" className="btn btn-ghost">View Members Area</Link>
      </div>
      {stats && (
        <>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10">
            {[["applications", "Applications"], ["members", "Members"], ["rsvps", "RSVPs"], ["posts", "Blog posts"]].map(([k, l]) => (
              <div key={k} className="card-soft p-6" data-testid={`stat-${k}`}>
                <p className="text-xs uppercase tracking-widest text-[#232b1b]/60">{l}</p>
                <p className="font-serif-h text-4xl text-[#577731] mt-2">{stats[k]}</p>
              </div>
            ))}
          </div>
          <p className="mt-4 text-xs text-[#232b1b]/60" data-testid="admin-email-note">
            Every submission is saved here and also emailed to {stats.notify_email}.
          </p>
        </>
      )}
      <Tabs defaultValue="applications" className="mt-10">
        <TabsList className="flex flex-wrap h-auto bg-[#dacac1]/40 rounded-full p-1">
          {TABS.map(([v, l]) => (
            <TabsTrigger key={v} value={v} data-testid={`admin-tab-${v}`} className="rounded-full data-[state=active]:bg-[#577731] data-[state=active]:text-white">{l}</TabsTrigger>
          ))}
        </TabsList>
        {TABS.map(([v, , C]) => (
          <TabsContent key={v} value={v} className="mt-8"><C /></TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
